import React from "react";
import CommonSendComponent from "../../components/CommonSendComponent";
import { SEND_CONFIGS } from "../../config/sendConfigs";
import Menu from "../Menu";

const SendCatelog = () => {
  return (
    <>
      <Menu />
      <CommonSendComponent config={SEND_CONFIGS.catalog} />
    </>
  );
};

export default SendCatelog;
